import messages from './cmsUpload.json' with { type: 'json' };

export const cmsUploadEn: Readonly<typeof messages> = messages;
